import { useCallback } from "react";

import { ScrollArea } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Text } from "components";
import { AppConstants, RouteConstants } from "constant";
import ChatUserItem from "pages/chat/users/item";
import { ChatResponse } from "types";
import { StorageUtils } from "utils";

import classes from "./DashboardMessagesContent.module.css";
import useDashboardChats from "./useDashboardChats";

const { STORAGE_CHAT_USER } = AppConstants;

const DashboardMessagesContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loading, unreadChats } = useDashboardChats();

  const handleOpenChat = useCallback(
    (chat: ChatResponse) => {
      StorageUtils.setObject(STORAGE_CHAT_USER, chat.user.id);
      navigate(RouteConstants.ROUTE_CHAT);
    },
    [navigate],
  );

  return (
    <div className={classes.root}>
      {loading ? (
        <Text className={classes.stateText}>{t("dashboard.messages.loading")}</Text>
      ) : unreadChats.length === 0 ? (
        <Text className={classes.stateText}>{t("dashboard.messages.empty")}</Text>
      ) : (
        <div className={classes.list}>
          <ScrollArea h="100%">
            {unreadChats.map((chat, index) => (
              <ChatUserItem
                key={chat.id}
                item={chat}
                index={index}
                t={t}
                activeChat={undefined}
                setActiveChat={handleOpenChat}
              />
            ))}
          </ScrollArea>
        </div>
      )}
    </div>
  );
};

export default DashboardMessagesContent;
